module.exports = __webpack_public_path__ + "static/media/scaffolder-video-002.4e91f392.mp4";